import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicQuandRecevoirPaiement = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Versements', link: '/topics/versements'},
    { label: "Fonctionnement des versements", link: '/topics/versements/fonctionnment-versements'}, 
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Bonne nouvelle : votre argent arrive ! 
              <br/>Le moment où vous recevrez votre versement dépend de comment vous avez configuré votre compte de versement.
            </p>
            <p className="help-text">
              Les paiements des inscriptions aux compétitions sont effectués uniquement par carte bancaire et sont gérés via Stripe. 
              Lorsqu’un athlète s’inscrit à une compétition, le montant de son inscription est collecté et stocké sur notre plateforme via Stripe Connect.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Lors de la création de votre compte de versement, vous pouvez choisir parmi trois options de versement :
              </p>
              <ul>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Versement quotidien : </strong>
                    Chaque paiement est traité et transféré 2 jours ouvrés après la transaction. <span className="fz-14 ml-8 op-9 fw-400">Exemple : Un paiement reçu le lundi sera versé sur le compte bancaire le mercredi (hors week-end et jours fériés).</span>
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Versement hebdomadaire : </strong>
                    Tous les paiements collectés au cours de la semaine sont versés chaque semaine, le jour que vous avez défini.
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Versement mensuel : </strong>
                    Tous les paiements du mois sont regroupés et versés le jour choisi par l’organisateur.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <ul>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Premier versement : </strong>
                    Stripe applique un délai de sécurité pour le premier versement d’un nouvel organisateur. Celui-ci peut prendre entre <strong>7 et 14 jours</strong>, 
                    le temps que Stripe vérifie les informations bancaires.
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Délais bancaires : </strong>
                    Une fois le versement effectué par Stripe, la banque de l’organisateur peut encore prendre <strong>1 à 3 jours</strong> ouvrés pour créditer le compte.
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Retards possibles : </strong>
                    En cas d’activité inhabituelle (montants élevés, changements récents sur le compte bancaire, etc.), 
                    Stripe peut effectuer des vérifications de sécurité entraînant un retard temporaire du versement.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Afin de garantir une gestion fluide des remboursements et des éventuels litiges, 
                un <strong>solde de réserve</strong> est automatiquement conservé sur votre compte de versement.
              </p>
              <p className="help-text">
                Ce montant correspond à <strong>4 fois le prix moyen d'une inscription</strong> sur votre événement. 
                Il reste disponible sur votre solde Stripe mais n'est pas inclus dans votre versement habituel, 
                vous permettant ainsi de couvrir en toute sérénité les remboursements ou contestations qui pourraient survenir.
              </p>
              <p className="help-text">
                Ce solde de réserve est <strong>automatiquement libéré</strong> après la date de votre événement, 
                selon votre fréquence de versement habituelle.
              </p>
              <ul>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Versement mensuel : </strong>
                    Si votre événement a lieu le 15 du mois, le solde de réserve sera versé avec votre paiement mensuel habituel, 
                    soit aux alentours du 1er du mois suivant.
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Versement hebdomadaire ou quotidien : </strong>
                    Le solde sera libéré dès le prochain versement suivant la date de l'événement.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part">{anchorsParts[3].content}</p>
              <p className="help-text">
                Pour consulter le détail de tous vos paiements, vous pouver le faire depuis votre portail
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>Admin,</a> dans l'onglet <strong>Paiements</strong>.
              </p>
              <p className="help-text">      
                Dans cet espace vous y trouverez :
              </p>
              <ul>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Inscriptions : </strong>
                    vous retrouverez l’ensemble de vos inscriptions, avec tous les détails, des statistiques et de nombreuses autres informations
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Solde : </strong>
                    Consultez le montant des versements en transit et suivez vos paiements en attente.
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Votre compte :</strong>
                    Modifiez vos préférences de versement, ajustez vos paramètres et complétez votre profil si des informations sont manquantes.
                  </p>
                </li>
                <li className="pl-8 mb-12">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Tous les paiements :</strong>
                    Si vous organisez plusieurs compétitions avec des inscriptions sur des périodes communes, le total de vos ventes sera affiché ici, 
                    regroupant toutes les transactions en un seul aperçu.
                  </p>
                </li>
              </ul>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicQuandRecevoirPaiement